<template>
  <div class="animated fadeIn" id="iframediv">
    <highcharts v-if="attiva" :options="chartOptions"></highcharts>
    <h1 v-if="nomodrel">Funzione non attiva</h1>
    <h1 v-else-if="!attiva">Funzione attiva solo dal 5 al 7 del mese</h1>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import { API } from "@/api.js";

// testare ad esempio con BBTLCA03M60F704N

export default {
  name: "showmodrel",
  components: {
    highcharts: Chart
  },
  mixins: [window.myMixin],
  data: function() {
    return {
      chartOptions: {},
      nomodrel: false,
    };
  },
  computed: {
    attiva: function() {
      var oggi = new Date();
      console.log("ATTIVA",this.getBackdoor())
      return (oggi.getDate()>=5 && oggi.getDate()<=7 && !this.nomodrel) || this.getBackdoor()
    }
  },
  props: [],
  methods: {},
  mounted: async function() {
    // var me = this
    // this.$http.get(window.baseurl+'/tshowpuntipers').then(response => {
    //     console.log("RESP:",response.data)
    //     me.chartOptions = response.data
    // })
    
    this.getCorsID()
    var mese = new Date().getMonth() // gennaio==0 : ok così perché mi interessa il mese precedente
    if(mese==0) mese=12 // però devo sistemare gennaio
    var als = await API.sqlprep(this, "modrel.votialunnomese", [
        this.getAlunnoID(),mese
    ]);
    var grps = {
      "Atteggiamento": 12,
      "Partecipazione":24,
      "Consegne":10,
      "Materiale":20,
      "Regolamento":34
    };
    console.log("ALS",this.getAlunnoID(),mese,als)
    
    var prg = await API.sqlprep(this, "registro.selalprog", [
        this.getAlunnoID()
    ]);
    this.nomodrel = prg.data.dati[0].nomodrel
    var series = {}
    try {
      series = als.data.dati.map( d => ({ name: d.gruppo, data: [d.v / grps[d.gruppo]]}))  
    } catch (error) { 
      console.error(error)
    }
    console.log("SERIES",series)
    this.chartOptions = {
      chart: {
        type: "column"
      },
      credits:{
        enabled:false
      },
      title: {
        text: "Modalità relazionali"
      },
      subtitle: {
        text: `Corsista: ${als.data.dati[0].cognome} ${als.data.dati[0].nome}`
      },
      xAxis: {
        categories: [""],
        crosshair: true
      },
      yAxis: {
        min: 0,
        max: 1,
        title: {
          text: "Punti"
        }
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0
        }
      },
      series: series
    };
  }
};
</script>

<style>
</style>
<style scoped>
</style>
